interface Currency {
  displayName: string;
  numericCode: number;
  defaultFractionDigits: number;
  subUnit: number;
  symbolSpaced: boolean;
  symbolPosition: "after" | "before";
  symbol: string;
  isoCode: "MRO";
};

const MRO: Currency = Object.freeze({
  "displayName": "Mauritanian Ouguiya",
  "numericCode": 478,
  "defaultFractionDigits": 2,
  "subUnit": 5,
  "symbolSpaced": true,
  "symbolPosition": "after",
  "isoCode": "MRO",
  "symbol": "UM"
});

export { MRO };
